import React, { useContext, useEffect, useState } from "react";
import { fireDB, auth, googleAuthProvider, messaging } from "./firebase";
import firebase from "firebase/app";
const AuthContext = React.createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState();
  const [moderator, setModerator] = useState();
  const [fcmToken, setFcmToken] = useState();

  const signInWithGoogle = async () => {
    await auth
      .setPersistence("session")
      .then(() => {
        return auth.signInWithPopup(googleAuthProvider);
      })
      .catch((err) => {
        console.log(`${err.code}: ${err.message}`);
      });
  };

  const signOutFromGoogle = async () => {
    await auth.signOut();
  };

  const dbRef = fireDB.ref();
  const increment = firebase.database.ServerValue.increment(1);

  useEffect(() => {
    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `messaging.onBackgroundMessage` handler.

    messaging.onMessage((payload) => {
      // console.log("Message received. ", payload);
      const title = payload.notification.title;
      const options = {
        body: payload.notification.body,
        icon: payload.notification.image,
        image: payload.notification.image,
      };

      const notification = new Notification(title, options);
      // ...
    });
  }, []);

  useEffect(() => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notification permission granted.");
        // TODO(developer): Retrieve a registration token for use with FCM.
        // ...
      } else {
        console.log("Unable to get permission to notify.");
      }
    });
  }, []);

  useEffect(() => {
    // Get registration token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    messaging
      .getToken({
        vapidKey:
          "BJgl8Is_AlpT_vL1EraT9rKcwmfwpGAQrQ-YlfdaTBj9dZXb5nv9UF3UPfgxRTqq-WN8MyI3zKNt0NegcIx1u7s",
      })
      .then((currentToken) => {
        if (currentToken) {
          // Send the token to your server and update the UI if necessary

          // ...
          setFcmToken(currentToken);
        } else {
          // Show permission request UI
          console.log(
            "No registration token available. Request permission to generate one."
          );
          // ...
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
        // ...
      });
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      if (user) {
        dbRef
          .child("users")
          .once("value", (snap) => {
            if (!snap.hasChild(user.uid)) {
              dbRef.child("users").child(user.uid).set({
                moderator: false,
                blogs: {},
              });
            }
          })
          .then(() => {
            dbRef.child(`users/${user.uid}`).once("value", (snap) => {
              setModerator(snap.val().moderator);
            });
          });
      }
    });

    return unsubscribe;
  }, []);

  const value = {
    signInWithGoogle,
    signOutFromGoogle,
    currentUser,
    moderator,
    dbRef,
    increment,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
